const parseApiUrl = (url) => {
  const noSlashApiUrl = url.lastIndexOf('/') === url.length - 1 ? url.slice(0, -1) : url
  const apiUrl =
    noSlashApiUrl.lastIndexOf('/api/v1') === -1 ? `${noSlashApiUrl}/api/v1` : noSlashApiUrl
  return apiUrl
}

export default parseApiUrl
